import { switchAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys)

const blackVariant = definePartsStyle({
  track: {
    _checked: {
      bg: 'black',
    },
  },
})

export const switchTheme = defineMultiStyleConfig({
  variants: { 'brand-black': blackVariant },
})
